import { render, staticRenderFns } from "./base-list.vue?vue&type=template&id=46519b56&scoped=true&"
import script from "./base-list.vue?vue&type=script&lang=ts&"
export * from "./base-list.vue?vue&type=script&lang=ts&"
import style0 from "./base-list.vue?vue&type=style&index=0&id=46519b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46519b56",
  null
  
)

export default component.exports